import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const DeleteIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.7531 2.47499H9.58752V1.99687C9.58752 1.15312 8.91252 0.478119 8.06877 0.478119H5.90315C5.0594 0.478119 4.3844 1.15312 4.3844 1.99687V2.47499H2.21877C1.40315 2.47499 0.728149 3.14999 0.728149 3.96562V4.80937C0.728149 5.42812 1.09377 5.93437 1.62815 6.15937L2.07815 15.4687C2.1344 16.6219 3.09065 17.5219 4.24377 17.5219H9.70002C10.8531 17.5219 11.8094 16.6219 11.8656 15.4687L12.3438 6.13124C12.8781 5.90624 13.2438 5.37187 13.2438 4.78124V3.93749C13.2438 3.14999 12.5688 2.47499 11.7531 2.47499ZM5.67815 1.99687C5.67815 1.85624 5.79065 1.74374 5.93127 1.74374H8.0969C8.23752 1.74374 8.35002 1.85624 8.35002 1.99687V2.47499H5.70627V1.99687H5.67815ZM2.0219 3.96562C2.0219 3.85312 2.10627 3.74062 2.2469 3.74062H11.7531C11.8656 3.74062 11.9781 3.82499 11.9781 3.96562V4.80937C11.9781 4.92187 11.8938 5.03437 11.7531 5.03437H2.2469C2.1344 5.03437 2.0219 4.94999 2.0219 4.80937V3.96562ZM9.72815 16.2562H4.2719C3.79377 16.2562 3.40002 15.8906 3.3719 15.3844L2.95002 6.27187H11.0781L10.6563 15.3844C10.6 15.8625 10.2063 16.2562 9.72815 16.2562Z"
      fill="#EEF7FF"
    />
    <path
      d="M7.00002 9.11249C6.66252 9.11249 6.35315 9.39374 6.35315 9.75936V13.3312C6.35315 13.6687 6.6344 13.9781 7.00002 13.9781C7.33752 13.9781 7.6469 13.6969 7.6469 13.3312V9.75936C7.6469 9.39374 7.33752 9.11249 7.00002 9.11249Z"
      fill="#EEF7FF"
    />
    <path
      d="M9.25006 9.675C8.88443 9.64687 8.60318 9.9 8.57506 10.2656L8.40631 12.7406C8.37818 13.0781 8.63131 13.3875 8.99693 13.4156C9.02506 13.4156 9.02506 13.4156 9.05318 13.4156C9.39068 13.4156 9.67193 13.1625 9.67193 12.825L9.84068 10.35C9.84068 9.98437 9.58756 9.70312 9.25006 9.675Z"
      fill="#EEF7FF"
    />
    <path
      d="M4.7219 9.675C4.3844 9.70312 4.10315 10.0125 4.13128 10.35L4.32815 12.825C4.35628 13.1625 4.63753 13.4156 4.9469 13.4156C4.97503 13.4156 4.97503 13.4156 5.00315 13.4156C5.34065 13.3875 5.6219 13.0781 5.59378 12.7406L5.3969 10.2656C5.3969 9.9 5.08753 9.64687 4.7219 9.675Z"
      fill="#EEF7FF"
    />
  </svg>
);

export default DeleteIconDark;
